import React from 'react';
export default function GoldenBootsSvg({ size = 40 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 12V28H4V34H18V28H14V12H8Z" fill="#FFB300" />
      <path d="M26 12V28H22V34H36V28H32V12H26Z" fill="#FFB300" />
      <rect x="8" y="12" width="6" height="3" fill="#FFD54F" />
      <rect x="26" y="12" width="6" height="3" fill="#FFD54F" />
      <polygon points="11,18 13,22 9,22" fill="#FFF8E1" />
      <polygon points="29,18 31,22 27,22" fill="#FFF8E1" />
    </svg>
  );
}
